import script from "./PointAndFigure.vue?vue&type=script&lang=js"
export * from "./PointAndFigure.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__